import instance, { ADMIN_PREFIX } from 'services/api';
import {
  DicomShareInput,
  DicomShareListResponse,
  DicomShareRow
} from 'types/api/dicomShares';

/**
 * BE returns the standard PaginatedResponse envelope ({data, total, page,
 * limit, totalPages}) with 1-based pagination. FE callers work in 0-based
 * pages (matches the legacy GQL + URL search-params).
 */
export const fetchDicomShares = async (query: {
  page?: number;
  limit?: number;
}): Promise<DicomShareListResponse> => {
  const res = await instance.get<{ data: DicomShareRow[]; total: number }>(
    `${ADMIN_PREFIX}/dicom-shares`,
    {
      params: {
        page: query.page ?? 1,
        limit: query.limit ?? 10
      }
    }
  );

  return {
    results: res.data.data ?? [],
    total: res.data.total ?? 0
  };
};

export const createDicomShare = (input: DicomShareInput) =>
  instance.post<DicomShareRow>(`${ADMIN_PREFIX}/dicom-shares`, input);

export const deleteDicomShare = (id: string | number) =>
  instance.delete<{ status: boolean }>(`${ADMIN_PREFIX}/dicom-shares/${id}`);
